import React from 'react';
import { BasicHeader } from '../../actions/BasicHeader';
import { ModalBottomButtonContainer } from './Styles';
import { SecondaryButton, SuccessButton } from '../connectedForm/Button';
import FluentModal from './FluentModal';

const ConfirmBulkActionModal = ({
  toBeClicked,
  setToBeClicked,
  numItemsEffected,
}: {
  toBeClicked: null | (() => void);
  setToBeClicked: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  numItemsEffected: number;
}) => {
  const handleYesButtonClick = () => {
    setToBeClicked(null);
    toBeClicked?.();
  };

  const handleNoButtonClick = () => {
    setToBeClicked(null);
  };

  const renderModalContent = () => {
    if (numItemsEffected === 0) {
      return (
        <div style={{ padding: '1em' }}>
          <p>No items selected. Action cancelled.</p>
          <ModalBottomButtonContainer>
            <SuccessButton inline={true} onClick={handleNoButtonClick}>
              OK
            </SuccessButton>
          </ModalBottomButtonContainer>
        </div>
      );
    } else {
      return (
        <div style={{ padding: '1em' }}>
          <p>This action will affect {numItemsEffected} item(s). Continue?</p>
          <ModalBottomButtonContainer>
            <SecondaryButton inline={true} onClick={handleNoButtonClick}>
              No
            </SecondaryButton>
            <SuccessButton
              inline={true}
              onClick={handleYesButtonClick}
              styles={{ root: { backgroundColor: '#00b9af' } }}
            >
              Yes
            </SuccessButton>
          </ModalBottomButtonContainer>
        </div>
      );
    }
  };

  const renderModalHeader = () => {
    if (numItemsEffected === 0) {
      return <BasicHeader>No Items Selected</BasicHeader>;
    } else {
      return <BasicHeader>Confirm Bulk Action</BasicHeader>;
    }
  };

  return (
    <FluentModal isOpen={!!toBeClicked} styles={{ main: { minWidth: '400px', paddingBottom: '60px' } }}>
      {renderModalHeader()}
      {renderModalContent()}
    </FluentModal>
  );
};

export default ConfirmBulkActionModal;
